import React from 'react';
import LevelLogo from './level-logo.svg';

// LEVEL wordmark (white-filled) for the dark sidebar, expanded state.
// height defaults to the standalone size; the sidebar lockup passes a
// smaller value so the "BACKSTAGE" product label fits beside it.
const LogoFull = ({ height = 80 }: { height?: number }) => {
  return <img src={LevelLogo} alt="LEVEL" style={{ height, width: 'auto' }} />;
};

export default LogoFull;
